import { Routes } from './routes'
import { GlobalStyle } from './styles/globals'

function App() {
  return (
    <>
      <GlobalStyle />
      <Routes />
    </>
  )
}

export default App
